import React from "react";
import "../../styles/demographic.css";
const Demographic = () => {
  return (
    <div className="container demographic-container">
      <div className="demographic-line"></div>
      <div className="demographic-content">
        <div className="demographic">
          <h1>Demographic</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim elit, sed do eiusmod tempor incididunt ut Lorem ipsum dolor
            sit amet, consectetur adipiscing elit, sed do Lorem ipsum dolor sit
            amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            ut labore et dolore magna aliqua. Ut enim ad minim elit,
          </p>
        </div>
        <div className="demographic">
          <h1>Filtering</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim elit, sed do eiusmod tempor incididunt ut Lorem ipsum dolor
            sit amet, consectetur adipiscing elit, sed do Lorem ipsum dolor sit
            amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            ut labore et dolore magna aliqua. Ut enim ad minim elit,
          </p>
        </div>
      </div>
    </div>
  );
};

export default Demographic;
